"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ActionTypes"));

var _RequestStatusTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/RequestStatusTypes"));

var initialState = _RequestStatusTypes.default.LOADING;

var PurchaseMotionRequestStatus = function PurchaseMotionRequestStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type;

  switch (type) {
    case _ActionTypes.default.PURCHASE_MOTION_DATA_REQUESTED:
      return _RequestStatusTypes.default.LOADING;

    case _ActionTypes.default.PURCHASE_MOTION_DATA_SUCCEEDED:
      return _RequestStatusTypes.default.SUCCEEDED;

    case _ActionTypes.default.PURCHASE_MOTION_DATA_FAILED:
      return _RequestStatusTypes.default.FAILED;

    default:
      return state;
  }
};

var _default = PurchaseMotionRequestStatus;
exports.default = _default;
module.exports = exports.default;